module.exports = __webpack_public_path__ + "media/HogeHall.e632a322.mp3";